export const atalPensionYojanaTable = [
  [42, 84, 126, 168, 210],
  [46, 92, 138, 183, 228],
  [50, 100, 150, 198, 248],
  [54, 108, 162, 215, 269],
  [59, 117, 177, 234, 292],
  [64, 127, 192, 254, 318],
  [70, 139, 208, 277, 346],
  [76, 151, 226, 301, 376],
  [82, 164, 246, 327, 409],
  [90, 178, 268, 356, 446],
  [97, 194, 292, 388, 485],
  [106, 212, 318, 423, 529],
  [116, 231, 347, 462, 577],
  [126, 252, 379, 504, 630],
  [138, 276, 414, 551, 689],
  [151, 302, 453, 602, 752],
  [165, 330, 495, 659, 824],
  [181, 362, 543, 722, 902],
  [198, 396, 594, 792, 990],
  [218, 436, 654, 870, 1087],
  [240, 480, 720, 957, 1196],
  [264, 528, 792, 1054, 1318],
]
